module.exports = __webpack_public_path__ + "static/exhibitors.8fdbd12b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/exhibitors.jpg
// module id = 988
// module chunks = 101932004231744